































































import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component
export default class UiInput extends mixins(PlanLimitsMixin) {
  @Prop()
  value: string;

  //0 -- not hide errors block 
  //1 -- hide errors block 
  //2 -- hide errors block , compensate hide
  @Prop({ default: 0 })
  hideDetails: number;

  @Prop()
  placeholder: string;

  @Prop()
  prefix: string;

  @Prop()
  suffix: string;

  @Prop()
  autocomplete: string;

  @Prop()
  errorMessages: string[];

  @Prop()
  disabled: boolean;

  @Prop()
  prependIcon: string;
  
  @Prop()
  prependInnerIcon: string;

  @Prop()
  appendIcon: string;
  
  @Prop()
  appendOuterIcon: string;

  @Prop()
  label: string;

  @Prop() 
  labelHelp: string;

  @Prop()
  name: string;

  @Prop()
  returnMaskedValue: string;

  @Prop()
  rows: number;

  @Prop()
  mask: string;

  @Prop()
  autofocus: string | boolean;

  @Prop()
  type: string;
  
  @Prop()
  maxlength: number;
  
  @Prop()
  readonly: boolean;
  
  iconPrefix: string = 'ui-input__icon';

  get pPrependIcon() {
    return this.prependIcon 
      ? `${this.prependIcon} ${this.iconPrefix}`
      : this.prependIcon;
  }

  get pPrependInnerIcon() {
    return this.prependInnerIcon 
      ? `${this.prependInnerIcon} ${this.iconPrefix}`
      : this.prependInnerIcon;
  }

  get pAppendIcon() {
    return this.appendIcon 
      ? `${this.appendIcon} ${this.iconPrefix}`
      : this.appendIcon;
  }

  get pAppendOuterIcon() {
    return this.appendOuterIcon 
      ? `${this.appendOuterIcon} ${this.iconPrefix}`
      : this.appendOuterIcon;
  }

  get hasError() {
    return !!this.errorMessages?.length
  }

  blur() {
    const textField = this.$refs.textField as any;
    textField.blur();
  }

  handleClick(e){
    if(!this.planLimitsEditable){
      e.preventDefault()
      return this.handleClickPlanLimits()
    }
  }
}
